import React from 'react';
import { fillFor } from '../wall/wallTokens';
import { T, RADIUS, BODY_FONT } from './messagesModel';
import { LockIcon } from './SecureLockSheet';

/**
 * "Use Face ID next time?" — a black card that rises above the inbox footer once, right
 * after the code opened the vault on a device with a face. YES enrols on the spot (the
 * code is still in hand); NOT NOW keeps the question away on this device — Settings
 * still has the switch.
 *
 *   offer  { label, accept, dismiss } from useSecureChats
 */
export default function BiometricOffer({ offer }) {
  if (!offer) return null;
  return (
    <div data-biometric-offer role="dialog" aria-label={`Use ${offer.label} next time?`} className="font-mono" style={{ position: 'absolute', left: '50%', bottom: 44, transform: 'translateX(-50%)', zIndex: 60, width: 320, maxWidth: 'calc(100% - 32px)', background: T.ink, color: T.white, borderRadius: RADIUS.row, padding: 14, display: 'flex', flexDirection: 'column', gap: 10, boxSizing: 'border-box' }}>
      <span className="flex items-center font-bold" style={{ gap: 8, fontSize: 11, letterSpacing: '.1em' }}>
        <LockIcon size={13} />
        USE {offer.label} NEXT TIME?
      </span>
      <span style={{ fontFamily: BODY_FONT, fontSize: 13, lineHeight: 1.4, color: 'rgba(255,255,255,.75)' }}>
        Skip the code on this device. Your PIN still works everywhere.
      </span>
      <div className="flex" style={{ gap: 8 }}>
        <button type="button" onClick={offer.accept} className="font-mono font-bold" style={{ height: 32, padding: '0 16px', borderRadius: RADIUS.pill, border: '2px solid transparent', background: fillFor('open'), color: T.ink, fontSize: 10, letterSpacing: '.1em', cursor: 'pointer' }}>
          YES
        </button>
        <button type="button" onClick={offer.dismiss} className="font-mono font-bold" style={{ height: 32, padding: '0 14px', borderRadius: RADIUS.pill, border: '2px solid rgba(255,255,255,.3)', background: 'transparent', color: T.white, fontSize: 10, letterSpacing: '.1em', cursor: 'pointer' }}>
          NOT NOW
        </button>
      </div>
    </div>
  );
}
